import { educationData } from '../../data/educationData'
import CardSection from '../shared/CardSection'
import { FaGraduationCap } from 'react-icons/fa'

const Education = () => (
  <CardSection
    id="educations"
    title="My Education"
    icon={<FaGraduationCap />}
    data={educationData}
    fields={['school', 'level', 'year']}
  />
)

export default Education
